// extracted by mini-css-extract-plugin
module.exports = {"root":"Messages_root__3UEbw","header":"Messages_header__3baNS"};